import axios from 'axios';
import config from '../config';

export default {
    getMakers() {
        return axios.get(config.apiUri + '/makers')
            .then(res => res.data.makers)
            .catch(e => Promise.reject(e));
    },
    getMaker(label) {
        return axios.get(config.apiUri + '/makers/?label=' + encodeURIComponent(label))
            .then(res => Promise.resolve(res.data.makers[0]))
            .catch(e => Promise.reject(e));
    },
    getModels(makerId) {
        return axios.get(config.apiUri + '/makers/' + makerId + '/models')
            .then(res => res.data.models)
            .catch(e => Promise.reject(e));
    },
    getModel(makerId, modelLabel) {
        return axios.get(config.apiUri + '/makers/' + makerId + '/models/?label=' + modelLabel)
            .then(res => Promise.resolve(res.data.models[0]))
            .catch(e => Promise.reject(e));
    },
    getBodyDesigns(modelId) {
        return axios.get(config.apiUri + '/models/' + modelId + '/body_designs')
            .then(res => res.data.body_designs)
            .catch(e => Promise.reject(e));
    },
    getBodyDesign(modelId, bodyDesignLabel) {
        return axios.get(config.apiUri + '/models/' + modelId + '/body_designs/?label=' + bodyDesignLabel)
            .then(res => res.data.body_designs[0])
            .catch(e => Promise.reject(e));
    },
    getTrimLevels(bodyDesignId) {
        return axios.get(config.apiUri + '/body_designs/' + bodyDesignId + '/trim_levels')
            .then(res => res.data.trim_levels)
            .catch(e => Promise.reject(e));
    },
    getTrimLevel(bodyDesignId, trimLevelLabel) {
        return axios.get(config.apiUri + '/body_designs/' + bodyDesignId + '/trim_levels/?label=' + encodeURIComponent(trimLevelLabel))
            .then(res => res.data.trim_levels[0])
            .catch(e => Promise.reject(e));
    },
    getCompairsion(engineId) {
        return axios.get(config.apiUri + '/engines/' + engineId + '/equipments_comparisons')
            .then(res => res.data)
            .catch(e => Promise.reject(e));
    },
    getEngines(trimLevelId) {
        return axios.get(config.apiUri + '/trim_levels/' + trimLevelId + '/engines?skipWltp=true&unstableApi=true')
            .then(res => res.data.engines)
            .catch(e => Promise.reject(e));
    },
    getEngine(trimLevelId, engineLabel) {
        return axios.get(config.apiUri + '/trim_levels/'+trimLevelId+'/engines/?label='+encodeURIComponent(engineLabel))
            .then(res => res.data.engines[0])
            .catch(e => Promise.reject(e));
    },
    getExtras(engineId) {
        return axios.get(config.apiUri + '/engines/'+engineId+'/extras/?include=rules')
            .then(res => res.data.extras)        
            .catch(e => Promise.reject(e));
    },
    getCarConfiguration(configurationId) {
        return axios.get(config.apiUri + '/car_configurations/?external_id='+configurationId)
            .then(res => res.data.car_configurations)
            .catch(e => Promise.reject(e))
    },
    saveCarConfiguration(carConfiguration) {
        return axios.post(config.apiUri+'/car_configurations/', carConfiguration)
            .then(res => res.data.car_configuration)
            .catch(e => Promise.reject(e));            
    },
    updateCarConfiguration(carConfiguration) {
        return axios.put(config.apiUri+'/car_configurations/'+carConfiguration.car_configuration.id, carConfiguration)
            .then(res => res.data.car_configuration)
            .catch(e => Promise.reject(e));            
    },
    submitOfferRequest(configurationId) {
        return axios.put(config.apiUri+'/offer_requests/'+configurationId).then(res => res)
        .catch(e => Promise.reject(e));
    },
    getOfferPdf(configurationId) {
        return axios.get(config.apiUri+'/pdf/offer/'+configurationId).then(res => res.data)
        .catch(e => Promise.reject(e));
    },
    getStandardEquipments(engineId) {
        return axios.get(config.apiUri+'/engines/'+engineId+'/standard_equipments/')
            .then(res => res.data.standard_equipments)
            .catch(e => Promise.reject(e));
    },
    dataPush(request) {
        return axios.post(config.apiUri+'/car_configurations/ef_data_push', request).then(res => res.data)
        .catch(e => Promise.reject(e));
    },
    offer(configurationId) {
        return axios.put(config.apiUri+'/offer_requests/'+configurationId).then(res => res.data)
        .catch(e => Promise.reject(e));
    },
    getConditions() {
        return axios.get(config.apiUri+'/conditions').then(res => res.data)
            .catch(e => Promise.reject(e));
    }
}